
export default class Operation {
    constructor(id, cscom) {
        if (!(this instanceof Operation)) {
            return new Operation(id, cscom);
        }
        this.cscom = cscom;
        this.id = id;

        if (this.id) {
            this.path = `/user-site-api/sync-operations/${this.id}`;
        } else {
            this.path = `/user-site-api/sync-operations`;
        }
    }

    get(data) {
        return this.cscom.req.get(this.path, null, data);
    }
    
    list(data) {
        return this.cscom.req.get(this.path, data);
    }

    cancel() {
        return this.cscom.req.put(this.path + "/cancel").then((result) => {
            return result;
        });
    }

    remove() {
        return this.cscom.req.del(this.path).then((result) => {
            return result;
        });
    }

}
